/**
 * Hat customizer: reads JSON config, optional Shopify variant list from Liquid.
 * "Find variant" picks the cart line; sewn vs heatpress from patch file.
 */
(function () {
  function buildDropdownRegistry(cfg) {
    const rows = [];
    for (const p of cfg.heatpressPatches || []) {
      rows.push({ patch: String(p).trim(), category: "heatpress" });
    }
    for (const p of cfg.sewnPatches || []) {
      rows.push({ patch: String(p).trim(), category: "sewn" });
    }
    return rows;
  }

  function imgQuery(params, fallbackW, fallbackQ) {
    const w = params && params.width != null ? params.width : fallbackW;
    const q = params && params.quality != null ? params.quality : fallbackQ;
    return `width=${w}&quality=${q}`;
  }

  function formatMoneyFromCents(cents, format) {
    const n = (Number(cents) || 0) / 100;
    const amount = n.toFixed(2);
    const amountNoDecimals = String(Math.round(n));
    const fmt = format || "${{ amount }}";
    return fmt
      .replace(
        /\{\{\s*amount_with_comma_separator\s*\}\}/gi,
        amount.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      )
      .replace(
        /\{\{\s*amount_no_decimals\s*\}\}/gi,
        amountNoDecimals,
      )
      .replace(/\{\{\s*amount\s*\}\}/gi, amount);
  }

  function patchLabelLists(resolveCfg) {
    const sewn = [
      "sewn real leather",
      "sewn",
      "real leather",
    ];
    const heatpress = [
      "heat pressed leatherette",
      "heat pressed",
      "heatpress",
      "leatherette",
    ];
    const out = {
      sewn: sewn.slice(),
      heatpress: heatpress.slice(),
    };
    const pa = resolveCfg && resolveCfg.patchAliases;
    if (pa && typeof pa === "object") {
      for (const x of pa.sewn || []) {
        const s = String(x).trim().toLowerCase();
        if (s) out.sewn.push(s);
      }
      for (const x of pa.heatpress || []) {
        const s = String(x).trim().toLowerCase();
        if (s) out.heatpress.push(s);
      }
    }
    return out;
  }

  function patchTypeFromShopifyOption(raw, resolveCfg) {
    const s = String(raw || "").trim().toLowerCase();
    if (!s) return null;
    const lists = patchLabelLists(resolveCfg);
    const matches = [];
    for (const kind of ["sewn", "heatpress"]) {
      for (const phrase of lists[kind]) {
        if (!phrase) continue;
        if (s === phrase || s.includes(phrase)) {
          matches.push({ kind, len: phrase.length });
          break;
        }
      }
    }
    matches.sort((a, b) => b.len - a.len);
    return matches.length ? matches[0].kind : null;
  }

  function tierLetterFromOption(raw) {
    const s = String(raw || "").trim().toUpperCase();
    if (!s) return "";
    if (/^[ABC]$/.test(s)) return s;
    const word = s.match(/\b([ABC])\b/);
    if (word) return word[1];
    const tail = s.match(/([ABC])\s*$/);
    return tail ? tail[1] : "";
  }

  function normalizeVariantMap(vm) {
    if (!vm || typeof vm !== "object")
      return {};
    const out = {};
    for (const k of Object.keys(vm)) {
      const row = vm[k];
      if (!row || typeof row !== "object")
        continue;
      out[k] = {};
      for (const t of Object.keys(row)) {
        const cell = row[t];
        if (cell == null) continue;
        if (
          typeof cell === "number" ||
          typeof cell === "string"
        ) {
          const n = Number(cell);
          if (!Number.isNaN(n)) out[k][t] = n;
        } else if (
          typeof cell === "object" &&
          cell["1"] != null
        ) {
          const n = Number(cell["1"]);
          if (!Number.isNaN(n)) out[k][t] = n;
        }
      }
    }
    return out;
  }


  function troopCartSectionHandlesForAdd() {
    try {
      if (
        typeof Shopify !== "undefined" &&
        Shopify.routes &&
        Shopify.routes.cart &&
        window.location.pathname === Shopify.routes.cart
      )
        return [
          "cart-drawer",
          "cart-desktop",
          "cart-mobile",
        ];
    } catch (e) {}
    return ["cart-drawer"];
  }

  function troopParsedCartFormFragment(htmlStr) {
    if (
      typeof htmlStr !== "string" ||
      !String(htmlStr).trim() ||
      typeof String.prototype.parse !== "function"
    )
      return null;
    try {
      return htmlStr.parse(".cart--form");
    } catch (e) {
      return null;
    }
  }

  function troopApplyCartSectionsPayload(sections) {
    if (!sections || typeof sections !== "object")
      return false;
    let applied = false;
    for (const [sectionKey, html] of Object.entries(
      sections,
    )) {
      const view =
        typeof sectionKey === "string"
          ? sectionKey.replace(/^cart-/, "")
          : "";
      if (!view) continue;
      const el = document.querySelector(
        `cart-element[data-view="${view}"]`,
      );
      if (
        !el ||
        typeof el.swapInNewContent !== "function"
      )
        continue;
      const frag = troopParsedCartFormFragment(
        String(html || ""),
      );
      if (!frag) continue;
      el.swapInNewContent(frag);
      if (
        el.dataset.view === "drawer" &&
        typeof el.updateSummaryHeight === "function"
      )
        el.updateSummaryHeight();
      if (typeof el.toggleLoadingDisplay === "function")
        el.toggleLoadingDisplay(true);
      applied = true;
      try {
        if (typeof window.trigger === "function")
          window.trigger("theme:cart:updated", el);
      } catch (e) {}
    }
    return applied;
  }

  async function troopFetchCartBadgeCount() {
    try {
      if (
        typeof Shopify === "undefined" ||
        !Shopify.routes ||
        !Shopify.routes.cart
      )
        return;
      const res = await fetch(
        `${Shopify.routes.cart}.js`,
      );
      if (!res.ok) return;
      const cart = await res.json();
      const n = Number(cart.item_count) || 0;
      document
        .querySelectorAll("[data-cart-count]")
        .forEach((node) =>
          node.setAttribute("data-cart-count", n),
        );
      document
        .querySelectorAll("cart-element")
        .forEach((el) =>
          el.setAttribute(
            "data-has-items",
            n > 0 ? "true" : "false",
          ),
        );
    } catch (e) {}
  }

  function troopOpenCartDrawerViaHeader() {
    const trig =
      document.querySelector(
        'a[data-drawer-open="right"][data-drawer-view="cart-drawer"]',
      ) ||
      document.querySelector(
        'button[data-drawer-open="right"][data-drawer-view="cart-drawer"]',
      );
    if (!trig) return;
    trig.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      }),
    );
  }

  function variantOptionStrings(v) {
    const out = [];
    for (const key of ["option1", "option2", "option3"]) {
      if (!v || v[key] == null) continue;
      const s = String(v[key]).trim();
      if (s) out.push(s);
    }
    return out;
  }

  function heatpressPatchTypeKey(filename) {
    const base = String(filename || "")
      .trim()
      .replace(/\.[^.]+$/, "")
      .toLowerCase();
    if (!base) return "";

    const stem = base.replace(/_\d+[a-z]?$/, "");
    const shapeAliases = [
      ["vertical_rectangle", "vertical_rectangle"],
      ["vert_rectangle", "vertical_rectangle"],
      ["vertical_square", "vertical_square"],
      ["rectangle", "rectangle"],
      ["square", "square"],
      ["circle", "circle"],
      ["badge", "badge"],
      ["oval", "oval"],
      ["hex", "hex"],
    ];

    for (const [needle, canonical] of shapeAliases) {
      if (stem === needle || stem.endsWith(`_${needle}`)) {
        return canonical;
      }
    }

    return stem;
  }

  function resolvePatchAndTierFromShopifyVariant(
    v,
    resolveCfg,
  ) {
    let patchKind = null;
    let tierKind = "";
    for (const s of variantOptionStrings(v)) {
      const p =
        patchTypeFromShopifyOption(
          s,
          resolveCfg,
        );
      if (p && !patchKind) patchKind = p;
      const t = tierLetterFromOption(s);
      if (t && !tierKind) tierKind = t;
      if (patchKind && tierKind) break;
    }
    return { patchKind, tierKind };
  }

  function findRowInShopifyVariantList(
    shopVariants,
    wantPatchType,
    wantHatTier,
    resolveCfg,
  ) {
    const tierNeeded = tierLetterFromOption(
      String(wantHatTier || ""),
    );
    let lastResortSoldOut = null;

    for (const v of shopVariants) {
      const { patchKind, tierKind } =
        resolvePatchAndTierFromShopifyVariant(
          v,
          resolveCfg,
        );

      if (patchKind !== wantPatchType) continue;
      if (tierKind !== tierNeeded) continue;
      if (v.available) return v;
      if (!lastResortSoldOut)
        lastResortSoldOut = v;
    }
    return lastResortSoldOut;
  }

  function findRowInThemeJsonMap(
    variantMap,
    wantPatchType,
    wantHatTier,
  ) {
    const tierNeeded = tierLetterFromOption(String(wantHatTier || ""));
    const row = variantMap && variantMap[wantPatchType];
    const id = row
      ? row[tierNeeded] ?? row[wantHatTier]
      : null;
    if (id == null || Number.isNaN(Number(id))) return null;
    return {
      id: Number(id),
      price: null,
      available: true,
      option1: "",
      option2: "",
    };
  }

  function findVariantRowForSelection(
    wantPatchType,
    wantHatTier,
    shopVariants,
    variantMap,
    resolveCfg,
  ) {
    if (shopVariants && shopVariants.length) {
      return findRowInShopifyVariantList(
        shopVariants,
        wantPatchType,
        wantHatTier,
        resolveCfg,
      );
    }
    // Fallback: use simplified variantMap structure with normalized keys
    const normalizedPatchType = String(wantPatchType || "").toLowerCase();
    const tierNeeded = tierLetterFromOption(String(wantHatTier || ""));
    const row = variantMap && variantMap[normalizedPatchType];
    const id = row ? row[tierNeeded] ?? row[wantHatTier] : null;
    if (id == null || Number.isNaN(Number(id))) return null;
    return {
      id: Number(id),
      price: null,
      available: true,
      option1: "",
      option2: "",
    };
  }

  function sewnOrHeatpressFromPatchFilename(
    patchFile,
    dropdownRows,
  ) {
    const name = String(patchFile || "").trim();
    const hit = dropdownRows.find(
      (x) => (x.patch || x.value || "").trim() === name,
    );
    if (hit && hit.category === "sewn") return "sewn";
    if (hit && hit.category === "heatpress")
      return "heatpress";
    if (name.toLowerCase().includes("with_"))
      return "sewn";
    return "heatpress";
  }

  /** Max logo bbox as a fraction of the patch raster (contain + margin inside patch slot). */
  const PATCH_LOGO_INSIDE_FRAC = 0.88;

  /** Shift+wheel factor (1 = no change vs `patchLogoScaleByType`). */
  const LOGO_USER_REL_MIN = 0.5;
  const LOGO_USER_REL_MAX = 2.5;

  function clampLogoUserRelMul(n) {
    const x = Number(n);
    if (!Number.isFinite(x)) return 1;
    return Math.min(
      LOGO_USER_REL_MAX,
      Math.max(LOGO_USER_REL_MIN, x),
    );
  }

  /**
   * Shape key for `patchLogoScaleByType` (order: specific shapes before generic `rectangle` / `square`).
   * @param {string} patchFile
   */
  function patchShapeKeyFromFilename(patchFile) {
    const s = String(patchFile || "").toLowerCase();
    if (s.includes("circle")) return "circle";
    if (s.includes("oval")) return "oval";
    if (s.includes("vertical_square")) return "vertical_square";
    if (
      s.includes("vertical_rectangle") ||
      s.includes("vert_rectangle") ||
      (s.includes("vert") && s.includes("rectangle"))
    )
      return "vertical_rectangle";
    if (s.includes("rectangle")) return "rectangle";
    if (s.includes("square") || s.includes("sqaure")) return "square";
    if (s.includes("badge")) return "badge";
    if (s.includes("hex")) return "hex";
    return "default";
  }

  function resolvePatchSafeArea(patchConfig, patchFile) {
    const cfg =
      patchConfig && typeof patchConfig === "object"
        ? patchConfig
        : {};
    const key = patchShapeKeyFromFilename(patchFile);
    return cfg[key] || cfg.default || {};
  }

  function isValidCloudinarySecureUrl(url) {
    const u = String(url || "").trim();
    return u.startsWith("https://");
  }

  function pctToFrac(raw, fallback) {
    const n = Number.parseFloat(String(raw || ""));
    if (!Number.isFinite(n)) return fallback;
    return n / 100;
  }

  function applyEngravedEffect(base64, patchSrc, onDone) {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;

      let patchColor = { r: 90, g: 60, b: 30 };
      const src = (patchSrc || "").toLowerCase();
      if (src.includes("grey")) patchColor = { r: 80, g: 80, b: 80 };
      else if (src.includes("black"))
        patchColor = { r: 40, g: 40, b: 40 };
      else if (src.includes("metal"))
        patchColor = { r: 100, g: 100, b: 100 };
      else if (src.includes("brown"))
        patchColor = { r: 90, g: 60, b: 30 };

      for (let i = 0; i < data.length; i += 4) {
        const r = data[i],
          g = data[i + 1],
          b = data[i + 2],
          a = data[i + 3];
        if (a === 0) continue;
        const brightness = 0.299 * r + 0.587 * g + 0.114 * b;
        if (brightness > 200) data[i + 3] = 0;
        else if (brightness > 130) {
          data[i] = patchColor.r;
          data[i + 1] = patchColor.g;
          data[i + 2] = patchColor.b;
          data[i + 3] = 80;
        } else {
          data[i] = patchColor.r;
          data[i + 1] = patchColor.g;
          data[i + 2] = patchColor.b;
          data[i + 3] = 255;
        }
      }
      ctx.putImageData(imageData, 0, 0);
      onDone(canvas.toDataURL());
    };
    img.src = base64;
  }

  function dataURLToBlob(dataURL) {
    const raw = String(dataURL || "");
    const comma = raw.indexOf(",");
    if (comma === -1) return null;
    const header = raw.slice(0, comma);
    const mimeMatch = header.match(/data:(.*?);/);
    const mime =
      mimeMatch && mimeMatch[1] ? mimeMatch[1].trim() : "image/png";
    const bin = raw.slice(comma + 1);
    let decoded;
    try {
      decoded = atob(bin);
    } catch (e) {
      return null;
    }
    const len = decoded.length;
    const buf = new Uint8Array(len);
    for (let i = 0; i < len; i++)
      buf[i] = decoded.charCodeAt(i);
    return new Blob([buf], { type: mime });
  }

  /** object-fit:contain — place image in cw×ch without squishing. */
  function fitImageContain(nw, nh, cw, ch) {
    if (!nw || !nh || !cw || !ch) {
      return { x: 0, y: 0, dw: cw, dh: ch };
    }
    const scale = Math.min(cw / nw, ch / nh);
    const dw = nw * scale;
    const dh = nh * scale;
    const x = (cw - dw) / 2;
    const y = (ch - dh) / 2;
    return { x, y, dw, dh };
  }

  // SV- one PNG: hat + patch + logo for uploads
  async function compositeHatPreviewToBlob({
    canvasW,
    canvasH,
    hatSrc,
    patchSrc,
    patchCategory = "sewn",
    logoDataUrl,
    isMobile,
    /** Pan in preview coords normalized by patch-slot width/height (matches on-screen drag). */
    panNormX = 0,
    panNormY = 0,
    /** Relative to default auto scale (contain-in-patch × PATCH_LOGO_INSIDE_FRAC). */
    scaleMultiplier = 1,
    patchConfig = {},
  }) {
    if (
      !hatSrc ||
      !patchSrc ||
      !logoDataUrl ||
      !String(logoDataUrl).startsWith("data:")
    ) {
      return null;
    }

    const loadCrossOrigin = () =>
      new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => resolve(img);
        img.onerror = () =>
          reject(new Error("hat_or_patch_load"));
        img.src = hatSrc;
      });

    const loadPatch = () =>
      new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => resolve(img);
        img.onerror = () =>
          reject(new Error("patch_load"));
        img.src = patchSrc;
      });

    const loadLogo = () =>
      new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = () =>
          reject(new Error("logo_load"));
        img.src = logoDataUrl;
      });

    try {
      const hat = /** @type {HTMLImageElement} */ (
        await loadCrossOrigin()
      );
      const patch = /** @type {HTMLImageElement} */ (
        await loadPatch()
      );
      const logo = /** @type {HTMLImageElement} */ (
        await loadLogo()
      );

      const W = canvasW;
      const H = canvasH;

      const canvas =
        document.createElement("canvas");
      canvas.width = W;
      canvas.height = H;
      const ctx = canvas.getContext("2d");
      if (!ctx) return null;

      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, W, H);

      const hnw = Math.max(
        1,
        hat.naturalWidth || hat.width || 1,
      );
      const hnh = Math.max(
        1,
        hat.naturalHeight || hat.height || 1,
      );
      const fit = fitImageContain(hnw, hnh, W, H);

      ctx.drawImage(
        hat,
        fit.x,
        fit.y,
        fit.dw,
        fit.dh,
      );

      /** Hat display rect (matches width:100%; height:auto in layout). */
      const bx = fit.x;
      const by = fit.y;
      const bw = fit.dw;
      const bh = fit.dh;

      const patchTopFrac = isMobile ? 0.38 : 0.45;
      const patchSizeScale =
        patchCategory === "heatpress" ? 1.15 : 1;
      const patchW = bw * 0.6 * patchSizeScale;
      const par =
        patch.naturalHeight /
        Math.max(1, patch.naturalWidth);
      const patchH = patchW * par;
      const cx = bx + bw / 2;
      const cy = by + bh * patchTopFrac;
      ctx.drawImage(
        patch,
        cx - patchW / 2,
        cy - patchH / 2,
        patchW,
        patchH,
      );

      const safe = resolvePatchSafeArea(patchConfig, patchSrc);
      const safeW = patchW * pctToFrac(safe.width, 0.62);
      const safeH = patchH * pctToFrac(safe.height, 0.48);
      const safeCx =
        cx + (pctToFrac(safe.left, 0.5) - 0.5) * patchW;
      const safeCy =
        cy + (pctToFrac(safe.top, 0.5) - 0.5) * patchH;
      const safeX = safeCx - safeW / 2;
      const safeY = safeCy - safeH / 2;

      const fill =
          PATCH_LOGO_INSIDE_FRAC * (Number(scaleMultiplier) || 1);
      const nw = logo.naturalWidth || 1;
      const nh = logo.naturalHeight || 1;
      const maxW = safeW * fill;
      const maxH = safeH * fill;
      const fitted = fitImageContain(nw, nh, maxW, maxH);
      const px = safeCx + (Number(panNormX) || 0) * safeW;
      const py = safeCy + (Number(panNormY) || 0) * safeH;

      ctx.save();
      ctx.beginPath();
      ctx.rect(safeX, safeY, safeW, safeH);
      ctx.clip();
      ctx.drawImage(
        logo,
        px - fitted.dw / 2,
        py - fitted.dh / 2,
        fitted.dw,
        fitted.dh,
      );
      ctx.restore();

      return await new Promise((resolve) => {
        canvas.toBlob(
          (blob) => resolve(blob),
          "image/png",
          0.92,
        );
      });
    } catch (e) {
      const msg =
        e && e.message ? e.message : String(e);
      console.warn(
        "[sv-custom-hats] compositeHatPreview:",
        msg,
        e,
      );
      return null;
    }
  }

  function mergeCloudinaryOverrides(cfg) {
    if (!cfg || typeof cfg !== "object") return;
    cfg.cloudinary =
      cfg.cloudinary && typeof cfg.cloudinary === "object"
        ? { ...cfg.cloudinary }
        : {};
    const el = document.getElementById("sv-hats-cloudinary-overrides");
    if (!el) return;
    const raw = String(el.textContent || "").trim();
    if (!raw) return;
    try {
      const o = JSON.parse(raw);
      if (String(o.cloudName || "").trim())
        cfg.cloudinary.cloudName = String(o.cloudName).trim();
      if (String(o.uploadPreset || "").trim())
        cfg.cloudinary.uploadPreset = String(o.uploadPreset).trim();
      if (String(o.folder || "").trim())
        cfg.cloudinary.folder = String(o.folder).trim();
    } catch (e) {
      console.warn("[sv-custom-hats] cloudinary overrides JSON invalid", e);
    }
  }

  function mergeSectionOverrides(cfg) {
    if (!cfg || typeof cfg !== "object") return;
    cfg.features =
      cfg.features && typeof cfg.features === "object"
        ? { ...cfg.features }
        : {};
    const el = document.getElementById("sv-hats-section-overrides");
    if (!el) return;
    const raw = String(el.textContent || "").trim();
    if (!raw) return;
    try {
      const o = JSON.parse(raw);
      if (typeof o.hatCompositeEnabled === "boolean")
        cfg.features.hatCompositeEnabled = o.hatCompositeEnabled;
    } catch (e) {
      console.warn(
        "[sv-custom-hats] section overrides JSON invalid",
        e,
      );
    }
  }

  function loadAppConfig() {
    const el = document.getElementById("sv-hats-app-config");
    if (!el || !String(el.textContent || "").trim()) {
      console.error("[sv-custom-hats] Missing or empty #sv-hats-app-config");
      return null;
    }
    try {
      const cfg = JSON.parse(el.textContent);
      mergeCloudinaryOverrides(cfg);
      mergeSectionOverrides(cfg);
      return cfg;
    } catch (e) {
      console.error("[sv-custom-hats] Invalid config JSON", e);
      return null;
    }
  }

  // Helper to match quantity to the correct price tier/bracket.
  function getPriceFromTiers(tiers, qty) {
    if (!tiers || typeof tiers !== "object") return null;

    const quantity = Math.max(1, Math.floor(Number(qty) || 1));
    let bestThresholdMatch = null;

    for (const [rawKey, rawPrice] of Object.entries(tiers)) {
      const key = String(rawKey).trim();
      const price = Number(rawPrice);
      if (!Number.isFinite(price)) continue;

      const rangeMatch = key.match(/^(\d+)\s*-\s*(\d+)$/);
      if (rangeMatch) {
        const min = Number(rangeMatch[1]);
        const max = Number(rangeMatch[2]);
        if (quantity >= min && quantity <= max) {
          return price;
        }
        continue;
      }

      const plusMatch = key.match(/^(\d+)\s*\+$/);
      if (plusMatch) {
        const min = Number(plusMatch[1]);
        if (
          quantity >= min &&
          (!bestThresholdMatch || min > bestThresholdMatch.min)
        ) {
          bestThresholdMatch = { min, price };
        }
        continue;
      }

      if (/^\d+$/.test(key)) {
        const min = Number(key);
        if (
          quantity >= min &&
          (!bestThresholdMatch || min > bestThresholdMatch.min)
        ) {
          bestThresholdMatch = { min, price };
        }
      }
    }

    return bestThresholdMatch ? bestThresholdMatch.price : null;
  }

  document.addEventListener("alpine:init", () => {
    const cfg = loadAppConfig();

    if (!cfg) {
      Alpine.data("CustomHatsConfigurator", () => ({
        init() {
          console.error("[sv-custom-hats] Configurator disabled (bad config).");
        },
      }));
      return;
    }

    const pricingTable = cfg.pricingTable;
    const variantMap = normalizeVariantMap(
      cfg.variantMap,
    );
    const svResolve =
      cfg.sv_variantResolve &&
      typeof cfg.sv_variantResolve === "object"
        ? cfg.sv_variantResolve
        : {};
    const hatVariants = cfg.hatVariants;
    const hatStyleLabels = cfg.hatStyleLabels;
    const hatStyleTier = cfg.hatStyleTier || {};
    const hatColorLabels = cfg.hatColorLabels || {};
    const patchNameMap = cfg.patchNameMap || {};
    const patchLogoScaleByType =
      cfg.patchLogoScaleByType &&
      typeof cfg.patchLogoScaleByType === "object"
        ? cfg.patchLogoScaleByType
        : {};

    /**
     * Returns logo scale for patchFile using patchLogoScaleByType[shape] or default.
     */
    function resolvePatchLogoScale(patchFile) {
      const f = String(patchFile || "").trim();
      if (!f) return 1;
      const shapeKey = patchShapeKeyFromFilename(f);
      let raw = patchLogoScaleByType[shapeKey];
      if (raw === undefined || raw === null)
        raw = patchLogoScaleByType.default ?? patchLogoScaleByType["default"];
      if (raw === undefined || raw === null) return 1;
      return raw;
    }

    const defaults = cfg.defaults || {};
    const strings = cfg.strings || {};
    const urls = cfg.urls || {};
    const cartLabels = cfg.cartPropertyLabels || {};
    const imgParams = cfg.imageParams || {};
    const fallbackVariantId = cfg.fallbackVariantId;
    const mobileBreakpointPx = cfg.mobileBreakpointPx ?? 768;

    function patchDisplayName(patchFile) {
      const k = patchFile.trim();
      if (patchNameMap[k]) return patchNameMap[k];
      return k;
    }

    const HAT_COLOR_STYLE_PREFIXES = new Set(["split", "solid"]);

    /** Insert spaces in PascalCase-ish tokens (HeatherGrey → Heather Grey). */
    function formatHatColorSegment(segment) {
      return String(segment || "")
        .trim()
        .replace(/([a-z\d])([A-Z])/g, "$1 $2")
        .replace(/\s+/g, " ")
        .trim();
    }

    /** Colors on line 1, Split/Solid on line 2; else "Black / Khaki". hatColorLabels overrides. */
    function formatHatColorLabel(filename) {
      const f = String(filename || "").trim();
      if (hatColorLabels[f]) return hatColorLabels[f];
      const m = f.match(/^\d+_(.+)_FRONT\.(jpe?g|png|webp)$/i);
      if (!m) {
        return f
          .replace(/\.[^.]+$/, "")
          .replace(/^[^_]*_/, "")
          .replace(/_/g, " ");
      }

      const parts = m[1].split("-").filter(Boolean);
      if (parts.length === 0) return m[1];

      const firstRaw = parts[0];
      const firstKey = String(firstRaw).toLowerCase();
      if (parts.length >= 2 && HAT_COLOR_STYLE_PREFIXES.has(firstKey)) {
        const styleWord = formatHatColorSegment(firstRaw);
        const colorParts = parts
          .slice(1)
          .map(formatHatColorSegment)
          .filter(Boolean);
        const colorsStr = colorParts.join(" / ");
        if (!colorsStr.length) return styleWord;
        return `${colorsStr}\n${styleWord}`;
      }

      return parts.map(formatHatColorSegment).join(" / ");
    }

    Alpine.data("CustomHatsConfigurator", () => ({
      _cfg: cfg,

      CDN: cfg.cdn,
      hatStyleSwatches: cfg.hatStyleSwatches || [],
      heatpressPatches: cfg.heatpressPatches || [],
      sewnPatches: cfg.sewnPatches || [],
      contactUrl: urls.contact || "/pages/contact-us",

      quantity: defaults.quantity ?? 1,
      selectedHatStyle: defaults.selectedHatStyle || "112",
      hatVariants,
      hatStyleLabels,

      colorFilenames: [],
      selectedColorFilename: "",

      patchCategory: defaults.patchCategory || "sewn",
      selectedStitching: defaults.selectedStitching || "black",
      patchSelectionFromSwatch: true,

      selectedPatchFile: "",
      selectedDropdownPatch: "",

      uploadedLogoBase64: null,
      logoOriginalSecureUrl: "",
      logoPreviewSecureUrl: "",
      cartLogoUploading: false,
      addToCartLoading: false,
      logoUploadError: "",
      _logoSelectionId: 0,
      _cartAddLock: false,

      logoSrc: "",
      logoWrapVisible: false,
      patchOverlaySrc: "",
      patchOverlayVisible: false,

      pricingText: "",
      _shopVariants: [],
      _moneyFormatStr: "${{ amount }}",
      _cartType: "",
      windowWidth:
        typeof window !== "undefined" ? window.innerWidth : 1024,

      dropdownOptionsBackup: [],

      hatImageUrl: "",

      /** Px offset vs patch-slot center — drag to adjust preview. */
      _logoPanX: 0,
      _logoPanY: 0,
      /** 1 = no extra scale; combined with `patchLogoScaleByType` for final `--sv-logo-scale-multiplier`. */
      _logoUserRelMul: 1,
      _wheelOnRootAttached: false,
      _wheelOnRoot: null,

      mobileBreakpointPx,

      get hatStyleTitle() {
        return (
          hatStyleLabels[this.selectedHatStyle] ||
          strings.hatStyleTitleFallback ||
          "Not selected"
        );
      },

      /** Single-line caption for heading (comma between lines). */
      get selectedColorTitle() {
        const fn = String(this.selectedColorFilename || "").trim();
        if (!fn) {
          return (
            strings.hatColorTitleFallback ||
            strings.notSelected ||
            strings.hatStyleTitleFallback ||
            "Not selected"
          );
        }
        return formatHatColorLabel(fn).replace(/\n+/g, ", ");
      },

      get isMobile() {
        return this.windowWidth < mobileBreakpointPx;
      },

      /**
       * `patchLogoScaleByType` (and optional filename override) × Shift+wheel relative factor.
       */
      effectiveLogoScaleMul() {
        const base = resolvePatchLogoScale(
          this.selectedPatchFile,
        );
        const rel = clampLogoUserRelMul(
          Number(this._logoUserRelMul) || 1,
        );
        return base * rel;
      },

      get logoManipCssVars() {
        return {
          "--sv-logo-scale-multiplier": String(
            this.effectiveLogoScaleMul(),
          ),
        };
      },

      get patchSafeAreaStyle() {
        const area = resolvePatchSafeArea(this._cfg.patchConfig, this.selectedPatchFile);
        return {
          top: area.top,
          left: area.left,
          width: area.width,
          height: area.height,
          transform: "translate(-50%, -50%)",
        };
      },

      /** Fine position on top of flex-centered default placement. */
      get logoImgInlineStyle() {
        return {
          transform: `translate(${this._logoPanX}px, ${this._logoPanY}px)`,
        };
      },

      cloudinaryEffective() {
        const c =
          (this._cfg && this._cfg.cloudinary) || {};
        return {
          cloudName: String(c.cloudName || "").trim(),
          uploadPreset: String(c.uploadPreset || "").trim(),
          folder: String(c.folder || "").trim(),
        };
      },

      /**
       * Theme or JSON `features.hatCompositeEnabled` (default true).
       * When false, only the original logo file is uploaded.
       */
      get hatCompositeUploadEnabled() {
        const f =
          (this._cfg && this._cfg.features) || {};
        if (typeof f.hatCompositeEnabled === "boolean")
          return f.hatCompositeEnabled;
        return true;
      },

      get cartLogoUploadStatusText() {
        return (
          strings.logoUploadingHint || "Uploading logo…"
        );
      },

      /** Block checkout when logo requires Cloudinary config, or uploads are in-flight. */
      get isAddToCartBlockedForLogo() {
        if (!this.uploadedLogoBase64) return false;
        const ce = this.cloudinaryEffective();
        if (!ce.cloudName || !ce.uploadPreset) return true;
        if (this.cartLogoUploading) return true;
        return false;
      },

      get sewnLightPatches() {
        return this.sewnPatches.filter((p) =>
          p.toLowerCase().includes("with_white"),
        );
      },

      get sewnDarkPatches() {
        return this.sewnPatches.filter((p) => {
          const pl = p.toLowerCase();
          return pl.includes("with_black") || pl.includes("with_brown");
        });
      },

      get heatpressDisplayPatches() {
        const out = [];
        const seen = new Set();
        for (const p of this.heatpressPatches || []) {
          const file = String(p || "").trim();
          if (!file || seen.has(file)) continue;
          seen.add(file);
          out.push(file);
        }
        return out;
      },

      get hatPreviewLargeUrl() {
        const u = String(this.hatImageUrl || "");
        if (!u) return "";
        if (/\bwidth=\d/.test(u)) return u;
        const q = imgQuery(imgParams.previewLarge, 2000, 85);
        return `${u}${u.includes("?") ? "&" : "?"}${q}`;
      },

      CDNThumb(filename) {
        const u = `${this.CDN}/${filename}`;
        const q = imgQuery(imgParams.swatchThumb, 150, 76);
        return `${u}${u.includes("?") ? "&" : "?"}${q}`;
      },

      colorDisplayLabel(filename) {
        return formatHatColorLabel(filename);
      },

      colorDisplayLabelAria(filename) {
        return formatHatColorLabel(filename).replace(/\n+/g, ", ");
      },

      patchThumbUrl(patchFile) {
        const f = String(patchFile || "").trim();
        const u = `${this.CDN}/${f}`;
        const q = imgQuery(imgParams.swatchThumb, 150, 76);
        return `${u}${u.includes("?") ? "&" : "?"}${q}`;
      },

      pickFirstColor() {
        const list = hatVariants[this.selectedHatStyle] || [];
        this.colorFilenames = list.slice();
        if (list.length) {
          this.selectedColorFilename = list[0];
          this.hatImageUrl = `${this.CDN}/${list[0]}`;
        }
      },

      hydrateDropdownOptions() {
        this.dropdownOptionsBackup = buildDropdownRegistry(cfg);
      },

      filteredDropdownRaw() {
        const category = this.patchCategory;
        return this.dropdownOptionsBackup.filter((o) => {
          const patchName = (
            o.patch ||
            o.value ||
            ""
          ).toLowerCase();
          if (category === "sewn") {
            if (this.selectedStitching === "white")
              return (
                o.category === "sewn" && patchName.includes("with_white")
              );
            return (
              o.category === "sewn" &&
              (patchName.includes("with_black") ||
                patchName.includes("with_brown"))
            );
          }
          return o.category === category;
        });
      },

      get filteredDropdownList() {
        return this.filteredDropdownRaw().map((o) => {
          const patch = (o.patch || o.value || "").trim();
          return {
            value: patch,
            label: patchDisplayName(patch),
          };
        });
      },

      presetDefaultsForPricingOnly() {
        const rows = this.filteredDropdownRaw();
        if (!rows.length) {
          this.selectedPatchFile = "";
          this.selectedDropdownPatch = "";
          return;
        }
        const patch = (
          rows[0].patch ||
          rows[0].value ||
          ""
        ).trim();
        this.selectedPatchFile = patch;
        this.selectedDropdownPatch = patch;
      },

      syncLayoutForPatch(/* patchFile */) {
        this.resetLogoManip();
      },

      patchLogoScaleFor(patchFile) {
        return resolvePatchLogoScale(patchFile);
      },

      /** Shape key from filename (for `patchLogoScaleByType`). */
      patchShapeKeyFor(patchFile) {
        return patchShapeKeyFromFilename(patchFile);
      },

      resetLogoManip() {
        this._logoPanX = 0;
        this._logoPanY = 0;
        this._logoUserRelMul = 1;
      },

      clampLogoPan() {
        const root =
          this.$root && typeof this.$root.querySelector === "function"
            ? this.$root
            : null;
        const safeArea =
          root &&
          root.querySelector(".sv-hats__preview-logo-wrap");
        if (!safeArea || !safeArea.offsetWidth) return;
        const mw = safeArea.offsetWidth * 0.5;
        const mh = safeArea.offsetHeight * 0.5;
        this._logoPanX = Math.max(
          -mw,
          Math.min(mw, this._logoPanX),
        );
        this._logoPanY = Math.max(
          -mh,
          Math.min(mh, this._logoPanY),
        );
      },

      logoPanStart(ev) {
        if (
          ev.pointerType !== "touch" &&
          ev.button !== 0
        )
          return;
        if (!this.logoWrapVisible) return;
        ev.preventDefault();
        const sx = ev.clientX;
        const sy = ev.clientY;
        const ox = this._logoPanX;
        const oy = this._logoPanY;
        const onMove = (e) => {
          this._logoPanX =
            ox + (e.clientX - sx);
          this._logoPanY =
            oy + (e.clientY - sy);
          this.clampLogoPan();
        };
        const onEnd = () => {
          window.removeEventListener(
            "pointermove",
            onMove,
          );
          window.removeEventListener(
            "pointerup",
            onEnd,
          );
          window.removeEventListener(
            "pointercancel",
            onEnd,
          );
        };
        window.addEventListener(
          "pointermove",
          onMove,
        );
        window.addEventListener(
          "pointerup",
          onEnd,
        );
        window.addEventListener(
          "pointercancel",
          onEnd,
        );
      },

      attachRootLogoWheel(root) {
        if (!root || this._wheelOnRootAttached) return;
        this._wheelOnRoot = (ev) => {
          if (!ev.shiftKey) return;
          const wrap = root.querySelector(
            ".sv-hats__preview-logo-wrap",
          );
          const t = ev.target;
          if (
            !wrap ||
            !this.logoWrapVisible ||
            !this.patchOverlayVisible ||
            !(t === wrap || wrap.contains(t))
          )
            return;
          ev.preventDefault();
          ev.stopPropagation();
          const step =
            ev.deltaX < 0 ? -0.036 : 0.036;
          const next = clampLogoUserRelMul(
            Number(this._logoUserRelMul || 1) + step,
          );
          this._logoUserRelMul = next;
        };
        root.addEventListener(
          "wheel",
          this._wheelOnRoot,
          { passive: false },
        );
        this._wheelOnRootAttached = true;
      },

      init() {
        if (!this.CDN) {
          console.error("[sv-custom-hats] config.cdn missing");
          return;
        }

        this.measureWidth();
        window.addEventListener("resize", () => this.measureWidth());
        const shopEl =
          this.$root &&
          this.$root.querySelector(".sv-hats__shopify");
        this._shopVariants = [];
        this._moneyFormatStr = "${{ amount }}";
        if (shopEl && String(shopEl.textContent).trim()) {
          try {
            const p = JSON.parse(
              shopEl.textContent,
            );
            if (p && Array.isArray(p.variants))
              this._shopVariants = p.variants;
            if (p && p.moneyFormat)
              this._moneyFormatStr = p.moneyFormat;
            if (p && p.cartType != null)
              this._cartType = String(p.cartType);
            if (
              String(this._cartType || "").trim() === ""
            ) {
              const hasDrawer = document.querySelector(
                'a[data-drawer-view="cart-drawer"][data-drawer-open="right"],button[data-drawer-view="cart-drawer"][data-drawer-open="right"]',
              );
              if (hasDrawer)
                this._cartType = "drawer";
            }
          } catch (e) {
            console.warn(
              "[sv-custom-hats] .sv-hats__shopify invalid",
              e,
            );
          }
        }
        queueMicrotask(() =>
          this.attachRootLogoWheel(this.$root),
        );

        this.hydrateDropdownOptions();
        this.pickFirstColor();

        this.patchCategory = defaults.patchCategory || "sewn";
        this.selectedStitching = defaults.selectedStitching || "black";
        this.patchSelectionFromSwatch = false;
        this.patchOverlayVisible = false;
        this.logoWrapVisible = false;

        this.presetDefaultsForPricingOnly();
        this.syncLayoutForPatch(this.selectedPatchFile);

        this.$watch("quantity", () => this.updatePrice());
        this.$watch("selectedHatStyle", () => this.updatePrice());
        this.$watch("selectedPatchFile", () => this.updatePrice());
        this.$watch("patchCategory", () => this.updatePrice());
        this.$watch("selectedDropdownPatch", () =>
          this.updatePrice(),
        );
        this.updatePrice();
      },

      measureWidth() {
        this.windowWidth = window.innerWidth;
      },

      async _postCloudinaryUpload(blobOrFile) {
        const ce = this.cloudinaryEffective();
        const fd = new FormData();
        fd.append("file", blobOrFile);
        fd.append("upload_preset", ce.uploadPreset);
        if (ce.folder) fd.append("folder", ce.folder);
        const r = await fetch(
          `https://api.cloudinary.com/v1_1/${ce.cloudName}/image/upload`,
          { method: "POST", body: fd },
        );
        const text = await r.text();
        let body;
        try {
          body = JSON.parse(text);
        } catch (e) {
          throw new Error(text || "Upload failed");
        }
        if (!r.ok) {
          const msg =
            (body && body.error && body.error.message) ||
            text ||
            "Upload failed";
          throw new Error(msg);
        }
        return body;
      },

      patchSwatchIsActive(patchFile) {
        const p = patchFile.trim();
        return (
          this.patchSelectionFromSwatch &&
          String(this.selectedPatchFile).trim() === p
        );
      },

      selectHatStyle(style) {
        this.selectedHatStyle = style;
        this.patchSelectionFromSwatch = false;
        this.pickFirstColor();
        this.clearPatchUiQuiet();
        this.presetDefaultsForPricingOnly();
        this.syncLayoutForPatch(this.selectedPatchFile);
        this.updatePrice();
      },

      selectColor(filename) {
        this.selectedColorFilename = filename;
        this.hatImageUrl = `${this.CDN}/${filename}`;
      },

      selectPatchCategory(category) {
        this.patchCategory = category;
        this.patchSelectionFromSwatch = false;
        this.clearPatchUiQuiet();
        this.presetDefaultsForPricingOnly();
        this.syncLayoutForPatch(this.selectedPatchFile);
        this.updatePrice();
      },

      selectStitching(stitch) {
        this.selectedStitching = stitch;
        this.patchSelectionFromSwatch = false;
        this.clearPatchUiQuiet();
        this.presetDefaultsForPricingOnly();
        this.syncLayoutForPatch(this.selectedPatchFile);
        this.updatePrice();
      },

      selectPatchSwatch(patchFile, swatchCat) {
        const file = patchFile.trim();
        this.patchSelectionFromSwatch = true;
        this.selectedPatchFile = file;
        this.selectedDropdownPatch = file;
        this.patchCategory = swatchCat;
        this.syncLayoutForPatch(file);
        this.applyPatchOverlay(file);
      },

      applyPatchOverlay(patchFile) {
        const file = patchFile.trim();
        const q = imgQuery(imgParams.patchOverlay, 1400, 85);
        this.patchOverlaySrc = `${this.CDN}/${file}?${q}`;
        this.patchOverlayVisible = true;

        if (this.uploadedLogoBase64) {
          applyEngravedEffect(
            this.uploadedLogoBase64,
            this.patchOverlaySrc,
            (dataUrl) => {
              this.logoSrc = dataUrl;
              this.logoWrapVisible = true;
            },
          );
        }
      },

      onDropdownPatchChange() {
        const file =
          String(this.selectedDropdownPatch || "").trim();
        if (!file) return;
        this.patchSelectionFromSwatch = false;
        this.selectedPatchFile = file;
        const opt = this.dropdownOptionsBackup.find(
          (x) =>
            (x.patch || x.value || "").trim() === file,
        );
        const cat =
          opt && opt.category
            ? opt.category
            : file.toLowerCase().includes("with_")
              ? "sewn"
              : "heatpress";
        this.patchCategory =
          cat === "sewn" ? "sewn" : "heatpress";
        this.syncLayoutForPatch(file);
        this.applyPatchOverlay(file);
      },

      clearPatchUiQuiet() {
        this.patchOverlayVisible = false;
        this.logoWrapVisible = false;
        if (!this.uploadedLogoBase64) this.logoSrc = "";
      },

      onLogoChange(event) {
        const file =
          event.target.files && event.target.files[0];
        if (!file) return;

        this.resetLogoManip();

        this._logoSelectionId += 1;
        const selId = this._logoSelectionId;

        this.logoOriginalSecureUrl = "";
        this.logoPreviewSecureUrl = "";
        this.logoUploadError = "";

        const reader = new FileReader();

        reader.onload = () => {
          if (selId !== this._logoSelectionId) return;

          this.uploadedLogoBase64 = reader.result;
          applyEngravedEffect(
            this.uploadedLogoBase64,
            this.patchOverlaySrc || "",
            (dataUrl) => {
              if (selId !== this._logoSelectionId) return;
              this.logoSrc = dataUrl;
              this.logoWrapVisible = true;
            },
          );
        };

        reader.readAsDataURL(file);
      },

      /**
       * Remove the uploaded logo, clear file input, reset all logo state and UI.
       */
      removeLogo() {
        // Clear file input value so the same file can be re-uploaded
        if (this.$refs && this.$refs.logoFileInput) {
          this.$refs.logoFileInput.value = "";
        } else {
          // fallback: try to find input
          const inp = this.$root && this.$root.querySelector('.sv-hats__logo-file');
          if (inp) inp.value = "";
        }
        // Reset all logo-related state
        this.uploadedLogoBase64 = null;
        this.logoOriginalSecureUrl = "";
        this.logoPreviewSecureUrl = "";
        this.logoUploadError = "";
        this.logoSrc = "";
        this.logoWrapVisible = false;
        this._logoSelectionId += 1; // invalidate any in-flight uploads
        this.resetLogoManip();
        // Remove preview overlay if present
        this.patchOverlayVisible = false;
        // Optionally, re-show patch overlay if patch is selected
        if (this.selectedPatchFile) {
          this.applyPatchOverlay(this.selectedPatchFile);
        }
      },

      updateQuantity(e) {
        const root = e && e.currentTarget ? e.currentTarget : this.$root;
        const input =
          (e &&
            e.target &&
            e.target.matches &&
            e.target.matches(".quantity-selector--input") &&
            e.target) ||
          (root &&
            root.querySelector &&
            root.querySelector(".quantity-selector--container input"));

        if (!input) return;

        const raw = String(input.value ?? "").trim();

        // Allow temporary empty while typing; enforce minimum on blur.
        if (raw === "") {
          if (e && (e.type === "blur" || e.type === "focusout")) {
            this.quantity = 1;
            input.value = "1";
          }
          return;
        }

        const num = Number(raw);
        if (!Number.isFinite(num) || num < 1) {
          this.quantity = 1;
          input.value = "1";
          return;
        }

        const normalized = Math.floor(num);
        this.quantity = normalized;
        if (input.value !== String(normalized)) {
          input.value = String(normalized);
        }
      },

      updatePrice() {
        const qty = Math.max(1, Math.floor(Number(this.quantity) || 1));

        const patch = String(this.selectedPatchFile || "").trim();
        if (!patch) {
          this.pricingText = "";
          return;
        }

        const patchKind = sewnOrHeatpressFromPatchFilename(
          patch,
          this.dropdownOptionsBackup,
        );
        // Capitalize for config lookup (e.g. "Sewn", "Heat Press")
        const patchCategory =
          patchKind === "sewn" ? "Sewn" : patchKind === "heatpress" ? "Heat Press" : "";

        const styleKey = this.selectedHatStyle;
        const styleGroup = hatStyleTier[styleKey] || "C";

        const patchTable = pricingTable[patchKind];
        if (!patchTable) {
          this.pricingText = "";
          return;
        }
        const styleTable = patchTable[styleGroup];
        if (!styleTable) {
          this.pricingText = "";
          return;
        }

        const unitDollars = getPriceFromTiers(styleTable, qty);
        if (unitDollars === undefined || unitDollars === null) {
          this.pricingText = "";
          return;
        }
        const unitCents = Math.round(Number(unitDollars) * 100);
        const totalCents = Math.round(unitCents * qty);
        const unitStr = formatMoneyFromCents(unitCents, this._moneyFormatStr);
        const totalStr = formatMoneyFromCents(totalCents, this._moneyFormatStr);
        this.pricingText = `Price per Hat: ${unitStr} | Total: ${totalStr}`;
      },

      async addToCart() {
        if (this._cartAddLock) return;
        this._cartAddLock = true;
        try {
          const quantity = Math.max(
            1,
            Math.floor(Number(this.quantity) || 1),
          );

          const ce = this.cloudinaryEffective();
          if (
            this.uploadedLogoBase64 &&
            (!ce.cloudName || !ce.uploadPreset)
          ) {
            alert(
              strings.logoCloudinaryMisconfigured ||
                "Logo hosting is not configured.",
            );
            return;
          }

          if (this.cartLogoUploading) return;

          this.addToCartLoading = true;

          const hatStyle = this.selectedHatStyle;
        const ns = strings.notSelected || "Not selected";
        const colorImage =
          this.selectedColorFilename || ns;

        let patchImage = "";
        let patchCat = "";

        const swSel =
          this.patchSelectionFromSwatch;
        let patchSrc =
          String(this.selectedPatchFile || "").trim();

        if (swSel && patchSrc) {
          patchImage = patchSrc;
          patchCat =
            this.patchCategory === "sewn"
              ? "sewn"
              : "heatpress";
        } else {
          patchSrc =
            String(this.selectedDropdownPatch || "").trim() ||
            patchSrc;
          patchImage =
            patchSrc || ns;
          const opt =
            this.dropdownOptionsBackup.find(
              (x) =>
                (x.patch || x.value || "").trim() ===
                patchSrc,
            );
          patchCat =
            opt && opt.category
              ? opt.category
              : patchSrc
                  .toLowerCase()
                  .includes("with_")
                ? "sewn"
                : patchSrc &&
                    patchSrc !== ns
                  ? "heatpress"
                  : ns;
        }

        const stitching =
          patchCat === "sewn"
            ? this.selectedStitching
            : strings.naStitching || "N/A";

        const styleGroup = hatStyleTier[hatStyle] || "C";
        const mKey =
          patchCat === "sewn" ? "sewn" : "heatpress";
        const cfgRow = findVariantRowForSelection(
          mKey,
          styleGroup,
          this._shopVariants,
          variantMap,
          svResolve,
        );
        const variantId =
          cfgRow && cfgRow.id != null
            ? cfgRow.id
            : fallbackVariantId;

        const logoInputEl =
          this.$root.querySelector(
            ".sv-hats__logo-file",
          );

        let fileName = "";
        if (
          logoInputEl &&
          logoInputEl.files &&
          logoInputEl.files[0]
        ) {
          fileName =
            logoInputEl.files[0].name ||
            "";
        }

        let logoOriginalUrlPost = "";
        let compositePreviewUrlPost = "";

        if (this.uploadedLogoBase64) {
          const originalFile =
            logoInputEl &&
            logoInputEl.files &&
            logoInputEl.files[0];

          const hasLogoPreview =
            String(this.logoSrc || "").startsWith(
              "data:",
            );

          if (!originalFile || !hasLogoPreview) {
            alert(
              strings.logoNeedsSuccessfulUpload ||
                "Upload your logo successfully before adding to cart.",
            );
            return;
          }

          const hatCompositeSrc =
            this.hatPreviewLargeUrl;
          const patchCompositeSrc =
            String(this.patchOverlaySrc || "");

          const slotEl =
            this.$root.querySelector(".sv-hats__preview-logo-wrap") ||
            this.$root.querySelector(".sv-hats__patch-slot");
          const slotW =
            slotEl &&
            Number(slotEl.offsetWidth) >
              2
              ? slotEl.offsetWidth
              : 0;
          const slotH =
            slotEl &&
            Number(slotEl.offsetHeight) >
              2
              ? slotEl.offsetHeight
              : 0;
          let panNormX = 0;
          let panNormY = 0;
          if (slotW > 0 && slotH > 0) {
            panNormX =
              this._logoPanX /
              slotW;
            panNormY =
              this._logoPanY /
              slotH;
          }
          const scaleMul =
            this.effectiveLogoScaleMul();

          this.cartLogoUploading = true;
          this.logoUploadError = "";

          try {
            const origRes =
              await this._postCloudinaryUpload(
                originalFile,
              );
            logoOriginalUrlPost = isValidCloudinarySecureUrl(
              origRes.secure_url,
            )
              ? String(origRes.secure_url).trim()
              : "";
            if (!logoOriginalUrlPost) {
              throw new Error("Invalid logo upload URL");
            }
            this.logoOriginalSecureUrl =
              logoOriginalUrlPost;

            let compositeBlob = null;

            if (this.hatCompositeUploadEnabled) {
              compositeBlob =
                await compositeHatPreviewToBlob({
                  canvasW: 800,
                  canvasH: 800,
                  hatSrc: hatCompositeSrc,
                  patchSrc: patchCompositeSrc,
                  patchCategory: this.patchCategory,
                  logoDataUrl: String(this.logoSrc),
                  isMobile: this.isMobile,
                  panNormX,
                  panNormY,
                  scaleMultiplier:
                    scaleMul,
                  patchConfig:
                    (this._cfg &&
                      this._cfg.patchConfig) ||
                    {},
                });
            }

            if (
              this.hatCompositeUploadEnabled &&
              compositeBlob &&
              compositeBlob.size
            ) {
              const compFile = new File(
                [compositeBlob],
                "hat-preview.png",
                { type: "image/png" },
              );
              const compRes =
                await this._postCloudinaryUpload(
                  compFile,
                );
              compositePreviewUrlPost =
                isValidCloudinarySecureUrl(
                  compRes.secure_url,
                )
                  ? String(compRes.secure_url).trim()
                  : "";
            } else if (this.hatCompositeUploadEnabled) {
              compositePreviewUrlPost = "";
              console.warn(
                "[sv-custom-hats] hat composite upload skipped:",
                strings.hatCompositeFailed ||
                  "Hat composite preview unavailable.",
                compositeBlob
                  ? "empty blob"
                  : "composite returned null",
              );
            }

            this.logoPreviewSecureUrl =
              compositePreviewUrlPost ||
              "";
          } catch (e) {
            console.error(e);
            this.logoOriginalSecureUrl = "";
            this.logoPreviewSecureUrl = "";
            this.logoUploadError =
              strings.logoUploadFailed ||
              "Logo upload failed. Please try again.";
            alert(this.logoUploadError);
            return;
          } finally {
            this.cartLogoUploading = false;
          }
        }

        const props = {
          [cartLabels.hatStyle || "Hat Style"]: hatStyle,
          [cartLabels.hatColor || "Hat Color"]: colorImage,
          [cartLabels.patchType || "Patch Type"]: patchImage,
          [cartLabels.patchCategory || "Patch Category"]: patchCat,
          [cartLabels.stitching || "Stitching"]: stitching,
          [cartLabels.logoOriginal ||
          "_Logo Image (Original)"]:
            logoOriginalUrlPost ||
            strings.notProvided ||
            "Not provided",
          [cartLabels.logoPreview ||
          "_Logo Image (Preview)"]:
            compositePreviewUrlPost ||
            strings.noLogoUploaded ||
            "No logo uploaded",
          [cartLabels.hatPreview || "Hat Preview"]:
            compositePreviewUrlPost ||
            strings.noLogoUploaded ||
            "No logo uploaded",
          [cartLabels.logo || "Logo"]:
            logoOriginalUrlPost ||
            strings.notProvided ||
            "Not provided",
          [cartLabels.logoFile || "Logo File"]:
            this.uploadedLogoBase64 &&
            logoOriginalUrlPost
              ? fileName ||
                strings.uploadedLogo ||
                "Uploaded Logo"
              : strings.noLogoUploaded || "No logo uploaded",
        };

        const afterCart = urls.afterAddToCart || "/cart";

        try {
          const useDrawerCart =
            String(this._cartType || "")
              .toLowerCase()
              .trim() === "drawer";

          const payload = useDrawerCart
            ? {
                items: [
                  {
                    quantity,
                    id: variantId,
                    properties: props,
                  },
                ],
                sections:
                  troopCartSectionHandlesForAdd(),
              }
            : {
                items: [
                  {
                    quantity,
                    id: variantId,
                    properties: props,
                  },
                ],
              };

          const response = await fetch(
            "/cart/add.js",
            {
              method: "POST",
              headers: {
                "Content-Type":
                  "application/json",
              },
              body:
                JSON.stringify(payload),
            },
          );
          if (!response.ok) {
            const txt =
              await response.text();
            throw new Error(
              txt ||
                "Cart request failed",
            );
          }

          const addResult =
            await response.json();

          let drawerHtmlOk = false;
          if (
            useDrawerCart &&
            addResult.sections &&
            typeof addResult.sections === "object"
          ) {
            drawerHtmlOk =
              troopApplyCartSectionsPayload(
                addResult.sections,
              );
          }

          await troopFetchCartBadgeCount();

          try {
            if (
              typeof window.trigger ===
                "function" &&
              variantId != null
            )
              window.trigger(
                "theme:cart:productAdded",
                variantId,
              );
          } catch (e2) {}

          if (useDrawerCart && drawerHtmlOk) {
            troopOpenCartDrawerViaHeader();
          } else {
            window.location.href =
              afterCart;
          }
        } catch (err) {
          alert(
            strings.cartAddError ||
              "Failed to add to cart. Please try again.",
          );
          console.error(err);
        }
        } finally {
          this.addToCartLoading = false;
          this._cartAddLock = false;
        }
      },
    }));
  });
})();
